import { render, staticRenderFns } from "./rightsDialog.vue?vue&type=template&id=5a9aeaec&scoped=true"
import script from "./rightsDialog.vue?vue&type=script&lang=js"
export * from "./rightsDialog.vue?vue&type=script&lang=js"
import style0 from "./rightsDialog.vue?vue&type=style&index=0&id=5a9aeaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9aeaec",
  null
  
)

export default component.exports